import { Dialog, Transition } from '@headlessui/react';
import { ButtonCTASmall, SpinnerSmall } from 'components/ui';
import querystring from 'querystring';
import { Fragment, useRef } from 'react';
import {
  useAddStoreMemberMutation,
  useGetStoreInfoQuery,
} from 'store/services/segmentsApi';

/**
 *
 * @param {{open:boolean, setOpen:Function, storeName:string}} param0
 * @returns
 */
export default function AddMember({ open, setOpen, storeName }) {
  const emailRef = useRef();
  const formRef = useRef();

  const queryParams = querystring.stringify({
    store_name: storeName,
  });

  const { data: storeInfo } = useGetStoreInfoQuery(queryParams, {
    skip: !!!storeName,
  });
  const [addMember, { isLoading }] = useAddStoreMemberMutation();

  function closeModal() {
    setOpen(false);
  }
  /** @param {*} event */
  const handleAddMember = (event) => {
    event.preventDefault();
    const { email } = event.target;

    const payload = {
      email: String(email.value),
      store_name: String(storeInfo?.store_name),
    };
    addMember({ payload, serializedStoreName: queryParams }).finally(() =>
      setOpen(false)
    );
  };

  return (
    <Transition show={open} as={Fragment}>
      <Dialog
        as="div"
        id="modal"
        className="fixed inset-0 z-10 overflow-y-auto"
        // @ts-ignore
        initialFocus={emailRef}
        static
        open={open}
        onClose={closeModal}
      >
        <div className="min-h-screen text-center md:px-4">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100 "
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-30 backdrop-filter backdrop-blur-sm" />
          </Transition.Child>

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="inline-block w-full max-w-xl my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
              <div className="w-full px-5 py-7 lg:px-12 bg-segments-accent-color-1 bg-opacity-5">
                <header className="flex items-center justify-between">
                  <div className="flex items-center space-x-5">
                    <Dialog.Title
                      as="h3"
                      className="text-2xl font-medium leading-6 text-gray-900"
                    >
                      Add member
                    </Dialog.Title>
                  </div>
                  <button
                    className="focus:outline-none"
                    onClick={() => {
                      setOpen(false);
                    }}
                  >
                    <svg
                      className="w-6 h-6 fill-current text-segments-dark"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </header>
              </div>
              <form
                className="px-4 text-gray-700 md:px-12"
                onSubmit={handleAddMember}
                // @ts-ignore
                ref={formRef}
              >
                <div className="pt-7">
                  <p>Email</p>
                  <input
                    type="email"
                    name="email"
                    className="w-full px-5 py-3 mt-3 placeholder-gray-400 border-gray-300 rounded-lg"
                    placeholder="Enter email"
                    // @ts-ignore
                    ref={emailRef}
                    spellCheck="false"
                    required
                  />
                </div>

                <div className="flex justify-between mt-10 mb-8">
                  <div>
                    <ButtonCTASmall
                      variant="secondary"
                      type="button"
                      onClick={() => setOpen(false)}
                    >
                      <p className="px-4 font-normal text-segments-13px">
                        Cancel
                      </p>
                    </ButtonCTASmall>
                  </div>
                  <div>
                    <ButtonCTASmall variant="main" type="submit">
                      <div className="w-20 font-bold text-segments-13px">
                        {isLoading ? <SpinnerSmall /> : 'Add'}
                      </div>
                    </ButtonCTASmall>
                  </div>
                </div>
              </form>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
